(function() {
  var Controller,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.DashboardDropdownController = (function(superClass) {
    extend(DashboardDropdownController, superClass);

    function DashboardDropdownController(scope) {
      this.scope = scope;
      this.open = false;
      this.show = false;
      this.scope.$on('dashboard:close', (function(_this) {
        return function() {
          return _this.open = false;
        };
      })(this));
    }

    DashboardDropdownController.prototype.toggle = function() {
      return this.open = !this.open;
    };

    DashboardDropdownController.prototype.close = function() {
      this.open = false;
      return this.scope.$broadcast('dashboard:closed');
    };

    return DashboardDropdownController;

  })(Controller);

}).call(this);
